import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error('Nedostaju REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY u .env.local fajlu!');
}

// Prijava važi samo dok je tab otvoren (sessionStorage): posle zatvaranja taba
// ili pregledača traži se nova prijava. Osvežavanje stranice u istom tabu je zadržava.
// Stara trajno sačuvana prijava (localStorage) se briše, da ne ostane na računaru.
try {
  Object.keys(window.localStorage)
    .filter((k) => k.startsWith('sb-') && k.endsWith('-auth-token'))
    .forEach((k) => window.localStorage.removeItem(k));
} catch { /* pregledač ne dozvoljava pristup — ignoriši */ }

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.sessionStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
